var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-icon",
    clipPath: "url(#clip0_910_7492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.4585 66.458C81.6617 51.2548 81.6617 26.6055 66.4585 11.4023C51.2553 -3.80086 26.606 -3.80086 11.4028 11.4023C-3.80037 26.6055 -3.80037 51.2548 11.4028 66.458C26.606 81.6612 51.2553 81.6612 66.4585 66.458Z",
    fill: "#3C7FD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.0566 27.125C24.4902 27.125 26.4629 25.1523 26.4629 22.7188C26.4629 20.2852 24.4902 18.3125 22.0566 18.3125C19.6231 18.3125 17.6504 20.2852 17.6504 22.7188C17.6504 25.1523 19.6231 27.125 22.0566 27.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60.2114 59.5479H52.2931V42.501C52.2931 40.5342 52.1276 39.4169 51.1832 38.4234C50.2381 37.4303 48.9529 36.7606 47.067 36.8067C44.6235 36.8665 42.6463 38.0067 42.015 39.6907C41.7125 40.4978 41.5435 42.1094 41.5435 42.8566C41.5435 43.7659 41.4807 45.0304 41.4807 45.8057V59.5479H33.5664V31.318H40.8646V35.2114C43.0564 31.1026 46.1529 29.9238 50.1991 29.9238C52.9304 29.9238 55.8235 30.9678 57.7095 32.8875C59.4959 34.7058 60.2114 37.731 60.2114 41.8814V59.5479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.0159 31.3179H18.0977V59.5478H26.0159V31.3179Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_7492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.8604,
    height: 77.8604,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.8dea1ee59e6daaf2ecbd5a4130d6cf71.svg";
export { ForwardRef as ReactComponent };